import React, {useState} from 'react';

export default function ShareLinkComponent() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <div
        className="dropdown"
        onClick={() => {
          setShowMenu(!showMenu);
        }}
        onBlur={() => {
          setShowMenu(false);
        }}
      >
        <button
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
          className="dropdown-toggle btn btn-sm btn-dark p-2"
        >
          {'Share Link'}
        </button>
        <div
          tabindex="-1"
          role="menu"
          container="body"
          aria-hidden="true"
          className={`dropdown-menu ${showMenu ? 'd-block' : ''}`}
        >
          <button
            type="button"
            tabindex="0"
            role="menuitem"
            className="dropdown-item"
          >
            {'Whatsapp'}
          </button>
          <button
            type="button"
            tabindex="0"
            role="menuitem"
            className="dropdown-item"
          >
            {'Facebook'}
          </button>
          <button
            type="button"
            tabindex="0"
            role="menuitem"
            className="dropdown-item"
          >
            {'Twitter'}
          </button>
          <button
            type="button"
            tabindex="0"
            role="menuitem"
            className="dropdown-item"
          >
            {'Instagram'}
          </button>
          <button
            type="button"
            tabindex="0"
            role="menuitem"
            className="dropdown-item"
          >
            {'Pinterest'}
          </button>
        </div>
      </div>
    </>
  );
}
